import axios from "axios";
import api from "./apiConfig";


export const getAllCategories = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const categoriesCall = await api.get('/categories', { params: data, headers: { 'x-auth-token': localStorage.getItem('token') } })
            // console.log(categoriesCall)
            let status = categoriesCall?.data?.status;
            let successData = categoriesCall?.data?.data;
            let message = categoriesCall?.data.message;

            if (status !== 200) {
                resolve([{ message, status }, null])
            } else {
                resolve([null, successData])

            }
        } catch (error) {
            resolve([{ message: error, status: 500 }, null])
        }
    })
}


export const createCategories = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const categoriesCall = await api.post('/categories', data, {
                headers: { 'x-auth-token': localStorage.getItem('token') }
            });
            let status = categoriesCall?.data?.status;
            let successData = categoriesCall?.data?.data;
            let message = categoriesCall?.data.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            reject(error);
        }
    });
}


export const updateCategory = async (category) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const categoryId = category.id || category._id;
            const response = await api.put(`/categories/${categoryId}`, {
                ...category,
            },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-auth-token': localStorage.getItem('token')
                    },
                });
            // console.log(response)
            let status = response?.data?.status;
            let successData = response?.data?.data;
            let message = response?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            console.error('Error updating category:', error);
            reject(error);
        }
    })
};


export const deleteCategory = async (categoryId) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const response = await api.delete(`/categories/${categoryId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': localStorage.getItem('token')
                },
            });

            // console.log(response)
            let status = response?.data?.status;
            let successData = response?.data?.data;
            let message = response?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }

        } catch (error) {
            console.error('Error deleting category:', error);
            reject(error);

        }
    })
};